import React, { Suspense, lazy } from 'react';
import { Routes as RouterRoutes, Route, useLocation, useNavigate } from 'react-router-dom';
import List10Q10K      from './report/list_10q10k';
import Latest10Q10K    from './report/latest_10q10k';
import App_transcript  from './report/App_transcript';
import ListNews        from './report/list_News';
import Income          from './financial/Income';
import Balance         from './financial/Balance';
import Cashflow        from './financial/Cashflow';
import TopCompanies    from './pages/topcompanies';
import TopMomentum     from './pages/top_momentum';
import Home            from './pages/Home';
import StockComparison from './pages/StockComparison';
import CrossWindowTest from './user/auth/CrossWindowTest';

import Profile         from './user/ProfilePage';
import Watchlist       from './user/WatchlistPage';
import NoticePage      from './user/NoticePage';
import RegisterDialog  from './user/auth/RegisterDialog';
import VerifyResultPage from './user/VerifyResultPage';


// 导入新的FinanceGPT组件
import FinanceGPT from './pages/finance-gpt';

// 如果导入了ActivityTracker
import activityTracker from './user/ActivityTracker';

import AboutMe from './pages/aboutme';
import Prices from './pages/Prices';
import MainInfo from './pages/maininfo';

// 懒加载大型组件
const Candlestick = lazy(() => import('./technical/Candlestick'));
const StockScreener = lazy(() => import('./pages/StockScreener'));
const KeyMetric = lazy(() => import('./financial/KeyMetric'));
const Estimate = lazy(() => import('./financial/estimate'));
const BusinessProduct = lazy(() => import('./report/business-product'));

function Routes({ transcriptData, setTranscriptData }) {
  const location = useLocation();
  const navigate = useNavigate();

  // 从 URL 获取 symbol 参数
  const getSymbolFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('symbol') || '';
  };

  return (
    <Suspense fallback={<div>加载中...</div>}>
      <RouterRoutes>
        <Route path="/" element={<Home />} />
        <Route path="/top-companies" element={<TopCompanies />} />
        <Route path="/top-momentum" element={<TopMomentum />} />
        <Route
          path="/list-10q10k"
          element={<List10Q10K initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/latest-10q10k"
          element={<Latest10Q10K initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/maininfo"
          element={<MainInfo initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/business-product"
          element={<BusinessProduct initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/list-news"
          element={<ListNews initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/transcript"
          element={
            <App_transcript
              initialSymbol={getSymbolFromUrl()}
              transcriptData={transcriptData}
              setTranscriptData={setTranscriptData}
            />
          } 
        />
        <Route path="/income" element={<Income initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/balance" element={<Balance initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/cashflow" element={<Cashflow initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/keymetric" element={<KeyMetric initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/estimate" element={<Estimate initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/watchlist" element={<Watchlist/>} />
        <Route path="/pages/finance-gpt" element={<FinanceGPT />} />
        <Route path="/pages/stock-comparison" element={<StockComparison />} />
        <Route path="/pages/stock-screener" element={<StockScreener />} />
        <Route path="/technical/:symbol" element={<Candlestick />} />
        <Route path="/notice" element={<NoticePage />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/prices" element={<Prices />} />
        <Route path="/register" element={<RegisterDialog open={true} onClose={() => navigate('/')} />} />
        <Route path="/verify-result" element={<VerifyResultPage />} />

        <Route path="/cross-window-test" element={<CrossWindowTest />} />
      </RouterRoutes>
    </Suspense>
  );
}

export default Routes;